import React from 'react'
import moment from 'moment'
import styled, { css } from 'styled-components'

import { InboxContactProps } from 'client/../decl'

import Icon from '../../../../../common/components/icons/index'
import { Inbox } from '../../../../../common/types/common.type'

const imag =
  'data:image/jpeg;base64,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'

export default function InboxContact(props: InboxContactProps) {
  const { onChangeChat, activeNumber } = props
  const { customer_number, message, created_at } = props.inbox

  const handleChangeChat = () => {
    if (onChangeChat) {
      onChangeChat(props.inbox)
    }
  }

  function formatDate(dateString) {
    if (dateString !== '---') {
      const date = moment(dateString)
      let formatString
      if (date.isSame(moment(), 'day')) {
        formatString = 'hh:mm a'
      } else if (date.isSame(moment().subtract(1, 'days'), 'day')) {
        formatString = '[Yesterday] '
      } else {
        formatString = 'DD/MM/YYYY '
      }

      return moment(dateString).format(formatString)
    } else {
      return '---'
    }
  }

  return (
    <Contact
      onClick={handleChangeChat}
      activeNumber={activeNumber}
      customer_number={customer_number}
    >
      <AvatarWrapper>
        <Avatar src={imag} />
      </AvatarWrapper>
      <Content>
        <TopContent>
          <Name>{customer_number}</Name>
          {created_at && message ? (
            <Time>{formatDate(created_at)}</Time>
          ) : (
            <Trailing {...props.inbox} />
          )}
        </TopContent>

        <BottomContent>
          <MessageWrapper>
            <Message {...props.inbox} />
          </MessageWrapper>

          {created_at && message && <Trailing {...props.inbox} />}
        </BottomContent>
      </Content>
    </Contact>
  )
}

function Message(props: Pick<Inbox, 'messageStatus' | 'message'>) {
  const { message, messageStatus, message_type, delivered_at, sent_at } = props

  if (!message) return <></>
  const truncatedMessage = message
    ? message.length > 32
      ? message.substring(0, 32) + '...'
      : message
    : ''
  return (
    <>
      {message_type === 'send' && (
        <Icon
          style={delivered_at ? { color: '#0da9e5' } : { color: 'gray' }}
          isRead={messageStatus === 'READ'}
          id={delivered_at ? 'doubleTick' : sent_at ? 'singleTick' : ''}
        />
      )}

      <Subtitle>{truncatedMessage}</Subtitle>
    </>
  )
}

function Trailing(props: Pick<Inbox, 'isPinned' | 'notificationsCount'>) {
  const { isPinned, notificationsCount } = props

  return (
    <div className="sidebar-contact__icons">
      {isPinned && <Icon id="pinned" className="sidebar-contact__icon" />}

      {notificationsCount !== undefined && notificationsCount > 0 && (
        <UnreadContact>{notificationsCount}</UnreadContact>
      )}

      <button
        style={{
          border: 'none',
          color: '#919191',
          background: 'transparent',
        }}
        aria-label="sidebar-contact__btn"
      >
        <Icon
          id="downArrow"
          className="sidebar-contact__icon sidebar-contact__icon--dropdown"
        />
      </button>
    </div>
  )
}

const Contact = styled.div<{
  activeNumber: number
  customer_number: number
}>`
  height: 72px;
  padding: 10px 20px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid rgb(237, 237, 237);
  cursor: pointer;
  background: ${(props) =>
    props.activeNumber === props.customer_number
      ? 'rgb(237, 237, 237)'
      : 'transparent'};

  &:hover {
    background: rgb(237, 237, 237);
  }

  .sidebar-contact__icons,
  &:not(:focus) .sidebar-contact__icons {
    display: flex;
    justify-content: center;
    align-items: center;
    transform: translateX(24px);
    transition: transform 0.5s ease;
  }

  &:hover .sidebar-contact__icons {
    transform: translateX(0);
    background: rgb(237, 237, 237);
  }

  .sidebar-contact__icons > * {
    margin-left: 8px;
    color: rgb(145, 145, 145);
  }

  .icon {
    color: rgb(237, 237, 237);
  }
`

const AvatarWrapper = styled.div`
  width: 50px;
  height: 50px;
  margin-right: 10px;
`

const Avatar = styled.img`
  border-radius: 50%;
  height: 100%;
  width: 100%;
  object-fit: cover;
  display: flex;
  align-items: center;
  justify-content: space-between;
`

const Content = styled.div`
  overflow: hidden;
  flex: 1;
`

const contentStyles = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

const TopContent = styled.div`
  margin-bottom: 2px;

  ${contentStyles}
`

const messageStyles = css`
  flex: 1;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`

const Name = styled.h2`
  color: '#000000';
  font-size: 1rem;
  font-weight: 500;

  ${messageStyles}
`

const Time = styled.span`
  font-size: 0.7rem;
  color: '#00000099';
`

const BottomContent = styled.div`
  ${contentStyles}
`

const MessageWrapper = styled.div`
  color: '#00000099';
  font-size: 0.85rem;
  margin-right: 3px;
  overflow: hidden;

  ${contentStyles}
`

const Subtitle = styled.span`
  margin-left: 3px;
`

const UnreadContact = styled.span`
  display: inline-block;
  color: 'white' !important;
  background-color: '#25D366';
  border-radius: 18px;
  min-width: 18px;
  height: 18px;
  padding: 0 3px;
  line-height: 18px;
  vertical-align: middle;
  text-align: center;
  font-size: 0.75rem;
  font-weight: 500;
`
